module.exports = __webpack_public_path__ + "img/second-day-4.4ec192ae.png";